import { z } from 'zod';
import { ArtistsWorkedWithSchema } from 'src/shared/types/teacher';

export const summaryDetailsSchema = z.object({
  documentId: z.nullable(z.string()),
  title: z.nullable(z.string()),
  duration: z.nullable(z.number()),
  numberOfVideos: z.nullable(z.number()),
  description: z.nullable(z.string()),
  stripeLink: z.nullable(z.string()),
  skillLevel: z.object({
    name: z.nullable(z.string()),
  }),
  thumbnail: z.object({
    url: z.nullable(z.string()),
  }),
  teacherProfiles: z.array(
    z.object({
      documentId: z.string(),
      displayName: z.nullable(z.string()),
      mainSubject: z.nullable(z.string()),
      artistsWorkedWith: z.nullable(ArtistsWorkedWithSchema),
      profilePicture: z.object({
        url: z.nullable(z.string()),
      }),
    }),
  ),
});

export type SummaryDetails = z.infer<typeof summaryDetailsSchema>;
